import cn from 'classnames';
import {
    Banner,
    Agent,
    ModelsService,
    AIDevelopmentResources,
    LargeModelEcosystemService,
    DataBuilder,
    BottomBanner,
    ServiceMode,
    SuccessCases,
    EnterpriseLevelCloudNativeHighAvailability,
    ComponentsAndMCPServices
} from '~/components/sections/aigallery/index';
import {useGlobalMoveAnimation} from '../utils/useHooks.js';
import styles from 'style/aigallery/common.module.less';

const Aigallery = () => {
    useGlobalMoveAnimation();
    return (
        <div className={cn(styles.qianfan, 'qf-new-wrapper')}>
            <Banner />
            <Agent />
            <ModelsService />
            <div
                style={{
                    'background-image': 'linear-gradient(180deg, #f6f7fa 0%, #faf7fa 95% , rgba(255,255,255,0.90)100%)'
                }}
            >
                <ComponentsAndMCPServices />
                <DataBuilder />
                <EnterpriseLevelCloudNativeHighAvailability />
                <SuccessCases />
                <AIDevelopmentResources />
                <ServiceMode />
            </div>
            <LargeModelEcosystemService />
            <BottomBanner />
        </div>
    );
};

export default Aigallery;
